import { reimbursementCategoryNameMessageKeys } from "#/components/views/reimbursements/reimbursementCategoryNameMessageKeys"

export type SubsidyAmounts = {
  max: number
  available: number
  processing: number
  used: number
  claimed: number
}

export type Subsidy = {
  planStarted: boolean
  planStartDate: string
  yearlyAmounts: SubsidyAmounts
  lifetimeAmounts: SubsidyAmounts
  hasCostShare: boolean
  reimbursementRules: ReimbursementRule[]
  hasUnlimitedBenefit: boolean
  reimbursementCategoryNameMessageKey: keyof typeof reimbursementCategoryNameMessageKeys
  reimbursementCategoryIconName?: string
  benefitType?: BenefitType
  // CREDIT plans only; null cap means not reimbursable.
  creditLifetimeMax?: number | null
  remainingCredits?: number | null
  // Absent means reimbursable.
  isReimbursable?: boolean
}

export enum BenefitType {
  FUND = "FUND",
  CREDIT = "CREDIT"
}

export type ReimbursementRule = {
  reimbursementPercent: number
  outOfPocketMaxState: OutOfPocketMaxState
  qmeState: QmeState
}

export enum OutOfPocketMaxState {
  ANY = "ANY",
  OOP_MAX_NOT_MET = "OOP_MAX_NOT_MET",
  OOP_MAX_MET = "OOP_MAX_MET"
}

export enum QmeState {
  ANY = "ANY",
  NON_QME = "NON_QME",
  QME = "QME"
}

export type Subsidies = Subsidy[]
